module.exports = __webpack_public_path__ + "img/e-rovinieta.2f1d871f.svg";